import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header d-flex justify-content-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 mb-2" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "form-floating col" }
const _hoisted_13 = ["disabled", "readonly"]
const _hoisted_14 = { class: "form-check form-switch ps-0" }
const _hoisted_15 = ["disabled", "readonly"]
const _hoisted_16 = { class: "small ms-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_18 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_19 = { class: "col-12 mb-2" }
const _hoisted_20 = {
  class: "input-group",
  id: "celuar-input-group"
}
const _hoisted_21 = { class: "w-100 small" }
const _hoisted_22 = {
  key: 1,
  class: "btn btn-outline-secondary dropdown-toggle col-3 col-sm-2 pe-xl-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  id: "celular-intl-code"
}
const _hoisted_23 = { class: "small d-inline-block w-75" }
const _hoisted_24 = { class: "dropdown-menu scrollable-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "dial-code text-end col-2 ps-0" }
const _hoisted_29 = { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }
const _hoisted_30 = { class: "flag-box mt-1" }
const _hoisted_31 = { class: "country-name ms-2" }
const _hoisted_32 = { class: "form-floating col-9 col-sm" }
const _hoisted_33 = ["disabled", "readonly"]
const _hoisted_34 = { class: "form-check form-switch text-truncate mb-0 lh-sm" }
const _hoisted_35 = ["disabled", "readonly"]
const _hoisted_36 = { class: "form-check form-switch text-truncate mb-0 lh-sm" }
const _hoisted_37 = ["disabled", "readonly"]
const _hoisted_38 = { class: "form-check form-switch ps-0" }
const _hoisted_39 = ["disabled", "readonly"]
const _hoisted_40 = { class: "col-12 col-xxl-6 mb-2" }
const _hoisted_41 = { class: "input-group" }
const _hoisted_42 = { class: "w-100 small" }
const _hoisted_43 = {
  key: 1,
  class: "btn btn-outline-secondary dropdown-toggle col-3 col-sm-2 col-xxl-3 pe-xl-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_44 = { class: "small d-inline-block w-75" }
const _hoisted_45 = { class: "dropdown-menu scrollable-menu" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["id"]
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "dial-code text-end col-2 ps-0" }
const _hoisted_50 = { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }
const _hoisted_51 = { class: "flag-box mt-1" }
const _hoisted_52 = { class: "country-name ms-2" }
const _hoisted_53 = { class: "form-floating col" }
const _hoisted_54 = ["disabled", "readonly"]
const _hoisted_55 = { class: "form-check form-switch ps-0" }
const _hoisted_56 = ["disabled", "readonly"]
const _hoisted_57 = { class: "col-12 col-xxl-6 mb-2" }
const _hoisted_58 = { class: "input-group" }
const _hoisted_59 = { class: "w-100 small" }
const _hoisted_60 = {
  key: 1,
  class: "btn btn-outline-secondary dropdown-toggle col-3 col-sm-2 col-xxl-3 pe-xl-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_61 = { class: "small d-inline-block w-75" }
const _hoisted_62 = { class: "dropdown-menu scrollable-menu" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["id"]
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "dial-code text-end col-2 ps-0" }
const _hoisted_67 = { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }
const _hoisted_68 = { class: "flag-box mt-1" }
const _hoisted_69 = { class: "country-name ms-2" }
const _hoisted_70 = { class: "form-floating col" }
const _hoisted_71 = ["disabled", "readonly"]
const _hoisted_72 = { class: "form-check form-switch ps-0" }
const _hoisted_73 = ["disabled", "readonly"]
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-12 mb-2" }
const _hoisted_76 = { class: "input-group" }
const _hoisted_77 = { class: "form-floating col" }
const _hoisted_78 = ["disabled", "readonly"]
const _hoisted_79 = { class: "form-check form-switch ps-0" }
const _hoisted_80 = ["disabled", "readonly"]
const _hoisted_81 = { class: "col-12 col-xl-6 mb-2" }
const _hoisted_82 = { class: "input-group" }
const _hoisted_83 = { class: "form-floating col" }
const _hoisted_84 = ["disabled", "readonly"]
const _hoisted_85 = { class: "form-check form-switch ps-0" }
const _hoisted_86 = ["disabled", "readonly"]
const _hoisted_87 = { class: "col-12 col-xl-6 mb-2" }
const _hoisted_88 = { class: "input-group" }
const _hoisted_89 = { class: "form-floating col" }
const _hoisted_90 = ["disabled", "readonly"]
const _hoisted_91 = { class: "form-check form-switch ps-0" }
const _hoisted_92 = ["disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.localContactInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[30] || (_cache[30] = _createElementVNode("h5", { class: "card-title mb-0" }, [
              _createElementVNode("i", { class: "far fa-comment fa-fw me-2" }),
              _createElementVNode("span", null, "Datos de Contacto")
            ], -1)),
            _createElementVNode("div", null, [
              (_ctx.editMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
                      class: "btn btn-sm btn-outline-danger me-2"
                    }, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                      _createTextVNode("Cancelar ", -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-success",
                      disabled: !_ctx.canSave || _ctx.saving,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
                    }, [
                      _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
                      _cache[28] || (_cache[28] = _createTextVNode("Guardar ", -1)),
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_5)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit())),
                      class: "btn btn-sm btn-outline-secondary"
                    }, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("i", { class: "fas fa-pen fa-fw" }, null, -1)
                    ]))])
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control fw-bold text-center rounded-0 rounded-start", _ctx.readOnlyClasses]),
                      id: "email",
                      placeholder: "E-mail",
                      ref: "email",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localContactInfo.email.data) = $event)),
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateEmailInput())),
                      disabled: !_ctx.editMode,
                      readonly: !_ctx.editMode
                    }, null, 42, _hoisted_13), [
                      [
                        _vModelText,
                        _ctx.localContactInfo.email.data,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[31] || (_cache[31] = _createElementVNode("label", {
                      for: "email",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "far fa-envelope fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " E-mail ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-email"
                  }, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-email"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-email",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localContactInfo.email.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_15), [
                        [_vModelCheckbox, _ctx.localContactInfo.email.visible]
                      ])
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.emailValidation.hasWarning)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fas fa-exclamation-circle fa-fw me-2" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.emailValidation.hasError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-2" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (!_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["input-group-text text-center col-3 col-sm-2", _ctx.readOnlyClasses]),
                        id: "mobile-dial-code-label"
                      }, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.localContactInfo.mobile.data.dialCode), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("button", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.localContactInfo.mobile.data.dialCode), 1)
                      ])),
                  _createElementVNode("ul", _hoisted_24, [
                    _createElementVNode("li", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.localContactInfo.mobile.data.dialCode = ''))
                    }, [...(_cache[35] || (_cache[35] = [
                      _createStaticVNode("<button class=\"country text-muted dropdown-item\" id=\"item-mobile-clear\" data-v-9beca320><span class=\"row\" data-v-9beca320><span class=\"dial-code text-center col-2 ps-0\" data-v-9beca320><i class=\"far fa-trash-alt fa-fw\" data-v-9beca320></i></span><span class=\"col d-flex flex-row align-items-center fw-lighter ps-0\" data-v-9beca320><span class=\"country-name ms-2\" data-v-9beca320> Limpiar </span></span></span></button>", 1)
                    ]))]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWithDialCodes, (country) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: country.alpha3code,
                        onClick: ($event: any) => (
                      _ctx.localContactInfo.mobile.data.dialCode = country.dialCode
                    )
                      }, [
                        _createElementVNode("button", {
                          class: "dropdown-item country",
                          id: 
                        'item-' +
                        country.alpha2Code.toLowerCase() +
                        '-preferred'
                      
                        }, [
                          _createElementVNode("span", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(country.dialCode), 1),
                            _createElementVNode("span", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, [
                                _createElementVNode("span", {
                                  class: _normalizeClass('d-block flag ' + country.alpha2Code)
                                }, null, 2)
                              ]),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(country.spanish), 1)
                            ])
                          ])
                        ], 8, _hoisted_26)
                      ], 8, _hoisted_25))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control fw-bold text-center rounded-0", _ctx.readOnlyClasses]),
                      id: "celular-number",
                      placeholder: "Celular",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localContactInfo.mobile.data.number) = $event)),
                      disabled: !_ctx.editMode,
                      readonly: !_ctx.editMode
                    }, null, 10, _hoisted_33), [
                      [
                        _vModelText,
                        _ctx.localContactInfo.mobile.data.number,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("label", {
                      for: "mobile",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "fas fa-mobile-alt fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " Celular ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text col col-sm-3 flex-column py-0 justify-content-center align-items-start", _ctx.readOnlyClasses]),
                    id: "same-number"
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input whatsapp-color",
                        type: "checkbox",
                        role: "switch",
                        id: "whatsapp",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localContactInfo.mobile.whatsapp) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sameForWhatsapp()))
                      }, null, 8, _hoisted_35), [
                        [_vModelCheckbox, _ctx.localContactInfo.mobile.whatsapp]
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("label", {
                        class: "form-check-label small opacity-100",
                        for: "whatsapp"
                      }, "Whatsapp", -1))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input telegram-color",
                        type: "checkbox",
                        role: "switch",
                        id: "whatsapp",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localContactInfo.mobile.telegram) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sameForTelegram()))
                      }, null, 8, _hoisted_37), [
                        [_vModelCheckbox, _ctx.localContactInfo.mobile.telegram]
                      ]),
                      _cache[38] || (_cache[38] = _createElementVNode("label", {
                        class: "form-check-label small opacity-100",
                        for: "telegram"
                      }, "Telegram", -1))
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-mobile"
                  }, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-mobile"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-mobile",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localContactInfo.mobile.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_39), [
                        [_vModelCheckbox, _ctx.localContactInfo.mobile.visible]
                      ])
                    ])
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  (!_ctx.editMode || _ctx.localContactInfo.mobile.whatsapp)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["input-group-text text-center col-3 col-sm-2", _ctx.readOnlyClassesExtra]),
                        id: "mobile-dial-code-label"
                      }, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.localContactInfo.whatsapp.data.dialCode), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("button", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.localContactInfo.whatsapp.data.dialCode), 1)
                      ])),
                  _createElementVNode("ul", _hoisted_45, [
                    _createElementVNode("li", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.localContactInfo.whatsapp.data.dialCode = ''))
                    }, [...(_cache[40] || (_cache[40] = [
                      _createStaticVNode("<button class=\"dropdown-item country text-muted\" id=\"item-whats-clear\" data-v-9beca320><span class=\"row\" data-v-9beca320><span class=\"dial-code text-center col-2 ps-0\" data-v-9beca320><i class=\"far fa-trash-alt fa-fw\" data-v-9beca320></i></span><span class=\"col d-flex flex-row align-items-center fw-lighter ps-0\" data-v-9beca320><span class=\"country-name ms-2\" data-v-9beca320> Limpiar </span></span></span></button>", 1)
                    ]))]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWithDialCodes, (country) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: country.alpha3code,
                        onClick: ($event: any) => (
                      _ctx.localContactInfo.whatsapp.data.dialCode = country.dialCode
                    )
                      }, [
                        _createElementVNode("button", {
                          class: "dropdown-item country",
                          id: 
                        'item-' +
                        country.alpha2Code.toLowerCase() +
                        '-preferred'
                      
                        }, [
                          _createElementVNode("span", _hoisted_48, [
                            _createElementVNode("span", _hoisted_49, _toDisplayString(country.dialCode), 1),
                            _createElementVNode("span", _hoisted_50, [
                              _createElementVNode("span", _hoisted_51, [
                                _createElementVNode("span", {
                                  class: _normalizeClass('d-block flag ' + country.alpha2Code)
                                }, null, 2)
                              ]),
                              _createElementVNode("span", _hoisted_52, _toDisplayString(country.spanish), 1)
                            ])
                          ])
                        ], 8, _hoisted_47)
                      ], 8, _hoisted_46))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control fw-bold text-center rounded-0", _ctx.readOnlyClassesExtra]),
                      id: "whatsapp",
                      placeholder: "Whatsapp",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.localContactInfo.whatsapp.data.number) = $event)),
                      disabled: !_ctx.editMode || _ctx.localContactInfo.mobile.whatsapp,
                      readonly: !_ctx.editMode || _ctx.localContactInfo.mobile.whatsapp
                    }, null, 10, _hoisted_54), [
                      [
                        _vModelText,
                        _ctx.localContactInfo.whatsapp.data.number,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("label", {
                      for: "whatsapp",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "fab fa-whatsapp fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " Whatsapp ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-whatsapp"
                  }, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-whatsapp"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_55, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-whatsapp",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.localContactInfo.whatsapp.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_56), [
                        [_vModelCheckbox, _ctx.localContactInfo.whatsapp.visible]
                      ])
                    ])
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  (!_ctx.editMode || _ctx.localContactInfo.mobile.telegram)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["input-group-text text-center col-3 col-sm-2", _ctx.readOnlyClassesExtra]),
                        id: "mobile-dial-code-label"
                      }, [
                        _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.localContactInfo.telegram.data.dialCode), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("button", _hoisted_60, [
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.localContactInfo.telegram.data.dialCode), 1)
                      ])),
                  _createElementVNode("ul", _hoisted_62, [
                    _createElementVNode("li", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.localContactInfo.telegram.data.dialCode = ''))
                    }, [...(_cache[43] || (_cache[43] = [
                      _createStaticVNode("<button class=\"dropdown-item country text-muted\" id=\"item-tlgm-clear\" data-v-9beca320><span class=\"row\" data-v-9beca320><span class=\"dial-code text-center col-2 ps-0\" data-v-9beca320><i class=\"far fa-trash-alt fa-fw\" data-v-9beca320></i></span><span class=\"col d-flex flex-row align-items-center fw-lighter ps-0\" data-v-9beca320><span class=\"country-name ms-2\" data-v-9beca320> Limpiar </span></span></span></button>", 1)
                    ]))]),
                    _createElementVNode("li", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.localContactInfo.telegram.data.dialCode = '@'))
                    }, [...(_cache[44] || (_cache[44] = [
                      _createStaticVNode("<button class=\"dropdown-item country\" id=\"item-tlgm-username\" data-v-9beca320><span class=\"row\" data-v-9beca320><span class=\"dial-code text-center col-2 ps-0\" data-v-9beca320> @ </span><span class=\"col d-flex flex-row align-items-center fw-lighter ps-0\" data-v-9beca320><span class=\"country-name ms-2\" data-v-9beca320> Nombre de usuario </span></span></span></button>", 1)
                    ]))]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWithDialCodes, (country) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: country.alpha3code,
                        onClick: ($event: any) => (
                      _ctx.localContactInfo.telegram.data.dialCode = country.dialCode
                    )
                      }, [
                        _createElementVNode("button", {
                          class: "dropdown-item country",
                          id: 
                        'item-' +
                        country.alpha2Code.toLowerCase() +
                        '-preferred'
                      
                        }, [
                          _createElementVNode("span", _hoisted_65, [
                            _createElementVNode("span", _hoisted_66, _toDisplayString(country.dialCode), 1),
                            _createElementVNode("span", _hoisted_67, [
                              _createElementVNode("span", _hoisted_68, [
                                _createElementVNode("span", {
                                  class: _normalizeClass('d-block flag ' + country.alpha2Code)
                                }, null, 2)
                              ]),
                              _createElementVNode("span", _hoisted_69, _toDisplayString(country.spanish), 1)
                            ])
                          ])
                        ], 8, _hoisted_64)
                      ], 8, _hoisted_63))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control fw-bold text-center rounded-0", _ctx.readOnlyClassesExtra]),
                      id: "telegram",
                      placeholder: "Telegram",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.localContactInfo.telegram.data.number) = $event)),
                      disabled: !_ctx.editMode || _ctx.localContactInfo.mobile.telegram,
                      readonly: !_ctx.editMode || _ctx.localContactInfo.mobile.telegram
                    }, null, 10, _hoisted_71), [
                      [_vModelText, _ctx.localContactInfo.telegram.data.number]
                    ]),
                    _cache[45] || (_cache[45] = _createElementVNode("label", {
                      for: "telegram",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "fab fa-telegram fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " Telegram ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-telegram"
                  }, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-telegram"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_72, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-telegram",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.localContactInfo.telegram.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_73), [
                        [_vModelCheckbox, _ctx.localContactInfo.telegram.visible]
                      ])
                    ])
                  ], 2)
                ])
              ])
            ]),
            _cache[53] || (_cache[53] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control text-center rounded-0 rounded-start", _ctx.readOnlyClasses]),
                      id: "instagram",
                      placeholder: "Instragram",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.localContactInfo.instagram.data) = $event)),
                      disabled: !_ctx.editMode,
                      readonly: !_ctx.editMode
                    }, null, 10, _hoisted_78), [
                      [
                        _vModelText,
                        _ctx.localContactInfo.instagram.data,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[47] || (_cache[47] = _createElementVNode("label", {
                      for: "mobile",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "fab fa-instagram fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " Instagram ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-instagram"
                  }, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-instagram"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-instagram",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.localContactInfo.instagram.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_80), [
                        [_vModelCheckbox, _ctx.localContactInfo.instagram.visible]
                      ])
                    ])
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control text-center rounded-0 rounded-start", _ctx.readOnlyClasses]),
                      id: "tiktok",
                      placeholder: "Tiktok",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.localContactInfo.tiktok.data) = $event)),
                      disabled: !_ctx.editMode,
                      readonly: !_ctx.editMode
                    }, null, 10, _hoisted_84), [
                      [
                        _vModelText,
                        _ctx.localContactInfo.tiktok.data,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("label", {
                      for: "tiktok",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "fab fa-tiktok fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " Tiktok ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-tiktok"
                  }, [
                    _cache[50] || (_cache[50] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-tiktok"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_85, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-tiktok",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.localContactInfo.tiktok.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_86), [
                        [_vModelCheckbox, _ctx.localContactInfo.tiktok.visible]
                      ])
                    ])
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control text-center rounded-0 rounded-start", _ctx.readOnlyClasses]),
                      id: "facebook",
                      placeholder: "Facebook",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.localContactInfo.facebook.data) = $event)),
                      disabled: !_ctx.editMode,
                      readonly: !_ctx.editMode
                    }, null, 10, _hoisted_90), [
                      [
                        _vModelText,
                        _ctx.localContactInfo.facebook.data,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[51] || (_cache[51] = _createElementVNode("label", {
                      for: "facebook",
                      class: "opacity-100"
                    }, [
                      _createElementVNode("i", { class: "fab fa-facebook fa-fw me-1" }),
                      _createElementVNode("span", { class: "" }, " Facebook ")
                    ], -1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group-text text-center flex-column pb-0", _ctx.readOnlyClasses]),
                    id: "share-facebook"
                  }, [
                    _cache[52] || (_cache[52] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "share-facebook"
                    }, " Visible ", -1)),
                    _createElementVNode("div", _hoisted_91, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input mt-0 ms-0 secondary",
                        type: "checkbox",
                        role: "switch",
                        id: "share-facebook",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.localContactInfo.facebook.visible) = $event)),
                        disabled: !_ctx.editMode,
                        readonly: !_ctx.editMode
                      }, null, 8, _hoisted_92), [
                        [_vModelCheckbox, _ctx.localContactInfo.facebook.visible]
                      ])
                    ])
                  ], 2)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}